import { all } from 'redux-saga/effects'

import { jobsSaga } from './jobs/sagas'

export function* employerSaga() {
  yield all([jobsSaga()])
}
